module.exports = __webpack_public_path__ + "img/close.ed8d023b.svg";